export default __webpack_public_path__ + "static/media/about-envio-correios.ae453b3e.png";